import React from 'react';
import { FOOTER_CALL_TO_ACTION, FOOTER_SIMPLE, FOOTER_SOCIAL_MEDIA_LINKS } from '../../../../../constants/portalConfigConstant';
import CallToActionItem from './CallToActionItem';
import SocialMediaLinksItem from './SocialMediaLinksItem';
import SimpleFooterItem from './SimpleFooterItem';

type FooterListItemProps = {
	items: any[];
	selectedTheme: any;
	handleUpdateFooterItem: (_id: any, _key: any, _value: any) => void;
	handleDeleteFooterItem: (_id: any) => void;
	handleDeleteSimpleFooterItem?: (_id: any) => void;
};
const FooterListItem = ({
	items,
	selectedTheme,
	handleUpdateFooterItem,
	handleDeleteFooterItem,
	handleDeleteSimpleFooterItem,
}: FooterListItemProps) => {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
			{items.map((item, index) => {
				return (
					<div key={index}>
						{item.footerType === FOOTER_CALL_TO_ACTION && (
							<CallToActionItem
								item={item}
								handleUpdateFooterItem={handleUpdateFooterItem}
								handleDeleteFooterItem={handleDeleteFooterItem}
							/>
						)}
						{item.footerType === FOOTER_SOCIAL_MEDIA_LINKS && (
							<SocialMediaLinksItem
								item={item}
								selectedTheme={selectedTheme}
								handleUpdateFooterItem={handleUpdateFooterItem}
								handleDeleteFooterItem={handleDeleteFooterItem}
							/>
						)}
						{item.footerType === FOOTER_SIMPLE && (
							<SimpleFooterItem
								item={item}
								handleDeleteFooterItem={handleDeleteSimpleFooterItem ?? handleDeleteFooterItem}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default FooterListItem;
